import { call, options, params } from './helpers';

export const getStoragePoints = (payload) =>
	call(`/beta/storage-points${params(payload)}`);
export const getAllStoragePointsConsumables = (payload) =>
	call(`/beta/storage-points/consumables${params(payload)}`);
export const getStoragePoint = ({ id }) => call(`/beta/storage-points/${id}`);
export const getStoragePointConsumables = ({ id }) =>
	call(`/beta/storage-points/${id}/consumables`);
export const addStoragePoint = (payload) =>
	call(`/beta/storage-points`, options(payload, 'POST'));
export const deleteStoragePoint = ({ id, resetInventory }) =>
	call(
		`/beta/storage-points/${id}${params({ resetInventory })}`,
		options(null, 'DELETE')
	);

export const addConsumableToStoragePointShelf = ({ id, ...payload }) => {
	return call(
		`/beta/storage-points/${id}/consumables/add`,
		options(payload, 'PUT')
	);
};

export const updateShelfStoragePoint = ({ id, ...payload }) =>
	call(`/beta/storage-points/${id}/shelves`, options(payload, 'PUT'));

export const addShelfStoragePoint = ({ id }) =>
	call(`/beta/storage-points/${id}/shelves/add`, options(null, 'PUT'));
